import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { URL, colors } from "../../../utils/constant";
import { useEffect } from "react";
import UseBloodSugarRecordList from "../../../data/talons/BloodSugarRecord/UseBloodSugarRecordList";
import { useDispatch, useSelector } from "react-redux";
import {
  getBloodSugarUpdate,
  getCalculateDate,
  getHypoUpdate,
  getPageId,
  getPageStatusData,
  getRecordDate,
} from "../../../data/selector/component.selector";
import { get, size } from "lodash";
import { getBloodSugarData } from "../../../data/selector/bloodSugarRecord.selector";
import Header from "../../../component/Header";
import FormSidebar from "../../../component/FormSidebar";
import { Box, Button, Grid, Stack } from "@mui/material";
import VisitNavbar from "../../../component/VisitNavbar";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSelectedVisit } from "../../../data/selector/visits.selector";
import usePageStatus from "../../../data/talons/PageStatus/usePageStatus";
import {
  getLanguage,
  getLanguageNumber,
} from "../../../data/selector/language.selector";
import { getUserToken } from "../../../data/selector/appState.selector";
import { addDays, format, parse } from "date-fns";
import {
  setCalculateDate,
  setPageId,
} from "../../../data/reducer/component.reducer";
import EditIcon from "@mui/icons-material/Edit";
import Dialogue from "../../../component/shared/Dialogue";
import HypoglycemiaList from "../Hypoglycemia/HypoglycemiaList";
import Hypoglycemia from "../Hypoglycemia/Hypoglycemia";
import BloodSugarRecord from "./BloodSugarRecord";
import {
  setBloodSugarFlag,
  setSelectedList,
} from "../../../data/reducer/bloodSugarRecord.reducer";
import { setSelectedLanguage } from "../../../data/reducer/language.reducer";
import { English } from "../../../Languages/en";
import { Spanish } from "../../../Languages/sp";
import useHypoglycemiaList from "../../../data/talons/Hypoglycemia/useHypoglycemiaList";
import { useHypoglycemia } from "../../../data/talons/Hypoglycemia/useHypoglycemia";
import useBloodSugarRecord from "../../../data/talons/BloodSugarRecord/UseBloodSugarRecord";

const BloodSugarRecordList = ({ className, flag }) => {
  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);
  const pageStatusData = useSelector(getPageStatusData);
  const { fetchBSRecordsList } = UseBloodSugarRecordList();
  const { fetchRecordsList } = useHypoglycemiaList();
  const { handleDropdownLanguageChange } = useBloodSugarRecord();
  const pageStatusObj = useSelector(getPageId);
  const { pageStatus, fetchPageStatus } = usePageStatus();
  const selectedVisitId = useSelector(getSelectedVisit);
  const visitId = selectedVisitId?.VisitId;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bloodSugarSelector = useSelector(getBloodSugarUpdate);
  const token = useSelector(getUserToken);
  const pageId = get(pageStatusObj?.pageData, "PageId", "");
  const listData = useSelector(getBloodSugarData);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(0);
  const [Open, setOpen] = useState(false);
  const [Alert, setAlert] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10); // Default rows per page
  const selector = useSelector(getHypoUpdate);
  const visitStartDate = selectedVisitId?.VisitStartDate;
  let calculatedDates = [""];

  const action = [
    {
      id: "Actions",
      label: Language.BloodSugarRecords?.action,
      minWidth: 100,
      align: "left",
    },
  ];

  const columns = [
    {
      id: "BS_DATE",
      label: Language.visitPageandStatus?.record_Date,
      minWidth: 150,
      align: "right",
    },
    { id: "BS_TIME", label: Language.BloodSugarRecords?.Time, minWidth: 100 },
    {
      id: "BS_MTIME",
      label: Language.BloodSugarRecords?.Meal_Time,
      minWidth: 150,
      align: "right",
    },
    {
      id: "MEAL",
      label: Language.BloodSugarRecords?.Meal_Code,
      minWidth: 180,
    },
    {
      id: "BS_SUGAR",
      label: Language.BloodSugarRecords?.Blood_sugar_value,
      minWidth: 150,
    },
    {
      id: "BS_INSULIN",
      label: Language.BloodSugarRecords?.Bolus_Insulin,
      minWidth: 150,
    },
    {
      id: "BS_ITYPE",
      label: Language.BloodSugarRecords?.insulin,
      minWidth: 150,
    },
    {
      id: "BS_BINSULIN",
      label: Language.BloodSugarRecords?.Basal_Insulin,
      minWidth: 150,
    },
    {
      id: "BS_INTYPE",
      label: Language.BloodSugarRecords?.insulin,
      minWidth: 150,
    },

    {
      id: "BS_UNITS",
      label: Language.BloodSugarRecords?.Pump_Insulin_Units,
      minWidth: 200,
    },
    {
      id: "BS_PTYPE",
      label: Language.BloodSugarRecords?.Pump_Insulin_Type,
      minWidth: 200,
    },
  ];

  useEffect(() => {
    if (size(token) === 0) {
      navigate(URL.login);
    }
  }, [token]);

  useEffect(() => {
    fetchPageStatus();
  }, [visitId]);

  useEffect(() => {
    if (!number) {
      dispatch(setSelectedLanguage(English));
    } else if (number == 1) {
      dispatch(setSelectedLanguage(English));
    } else if (number == 2) {
      dispatch(setSelectedLanguage(Spanish));
    }
  }, [number]);

  useEffect(() => {
    const newStartIndex = page * rowsPerPage;
    const newEndIndex = newStartIndex + rowsPerPage;
    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);
  }, [page, rowsPerPage, pageId, listData?.length]);
  useEffect(() => {
    setPage(0);
  }, [pageId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset page to 0 when rows per page changes
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: colors.blue,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const handleSelectedPage = () => {
    const currentPage = pageStatusData?.map((item) => {
      let dayCount = get(item, "PageId");
      dayCount =
        dayCount === 25
          ? 1
          : dayCount === 48
          ? 2
          : dayCount === 49
          ? 3
          : dayCount === 50
          ? 4
          : dayCount === 51
          ? 5
          : dayCount === 52
          ? 6
          : dayCount === 53
          ? 7
          : 1;
      const calculatedDate = calculateDate(dayCount);
      calculatedDates.push(calculatedDate);
      dispatch(setCalculateDate(calculatedDates));
    });
  };

  function calculateDate(daysToAdd) {
    const parsedStartDate = parse(visitStartDate, "dd/MMM/yyyy", new Date());
    const newDate = addDays(parsedStartDate, daysToAdd - 1);
    const newDateString = format(newDate, "dd/MMM/yyyy");

    return newDateString;
  }

  useEffect(() => {
    handleSelectedPage();
  }, [pageStatusData, pageStatus]);

  const path = window.location.pathname === URL.form;
  const dateArray = useSelector(getCalculateDate);
  const dateSelector = useSelector(getRecordDate);
  useEffect(() => {
    if (bloodSugarSelector?.recordNo !== 8) {
      const index = dateArray?.findIndex((date) => date === dateSelector);
      const pageStatusobj = {
        pageData: pageStatusData[index - 1],
      };
      dispatch(setPageId(pageStatusobj));
    }
  }, [dateSelector, dateArray, bloodSugarSelector]);

  useEffect(() => {
    if (selector) {
      fetchRecordsList(pageId);
    } else {
      fetchBSRecordsList(pageId);
    }
  }, [pageId, bloodSugarSelector]);
  return (
    <Grid
      sx={{
        backgroundColor: "whitesmoke",
        height: "100vh",
        display: "flex",
      }}
    >
      <Header />
      <VisitNavbar />
      <FormSidebar
        selectedVisitId={selectedVisitId}
        calculatedDates={calculatedDates}
        dateSelector={dateSelector}
      />
      <Dialogue open={Open} setOpen={setOpen} Alert={Alert} />
      {path ? (
        selector || bloodSugarSelector?.recordNo == 8 ? (
          <Hypoglycemia
            selectedVisitId={selectedVisitId}
            calculatedDates={calculatedDates}
          />
        ) : (
          <BloodSugarRecord
            selectedVisitId={selectedVisitId}
            calculatedDates={calculatedDates}
          />
        )
      ) : selector || bloodSugarSelector?.recordNo == 8 ? (
        <HypoglycemiaList />
      ) : (
        <Paper
          sx={{
            height: "fit-content",
            marginLeft: "410px",
            overflow: "hidden",
            mt: 9,
            mr: 2.5,
          }}
        >
          <Box className="d-flex justify-content-between flex-row-reverse pt-4 ps-2">
            <Box
              className="d-flex align-items-center gap-3"
              sx={{
                width: "fit-content",
              }}
            >
              <Button
                onClick={() => {
                  if (listData?.length >= 10) {
                    setOpen(true);
                    setAlert(Language.AlertMsg.maxLimitToEnterForm);
                  } else {
                    dispatch(setSelectedList(null));
                    dispatch(setBloodSugarFlag(false));
                    navigate(URL.form);
                  }
                }}
                variant="contained"
                className="fw-bold"
                style={{
                  marginRight: 15,
                  borderRadius: 0,
                  backgroundColor: colors.blue,
                  color: "white",
                  lineHeight: 2.5,
                  // width: 100,
                  border: "none",
                  fontSize: 12,
                }}
              >
                {Language.ButtonText.Add_New_Entry}
              </Button>
            </Box>
          </Box>
          <TableContainer sx={{ maxHeight: 440, mt: 4 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {action?.map((column) => (
                    <StyledTableCell
                      key={column?.id}
                      align={"left"}
                      style={{
                        minWidth: column?.minWidth,
                        fontWeight: 800,
                      }}
                    >
                      {column?.label}
                    </StyledTableCell>
                  ))}
                  {columns?.map((column) => (
                    <StyledTableCell
                      key={column?.id}
                      align={"left"}
                      style={{
                        minWidth: column?.minWidth,
                        fontWeight: 800,
                      }}
                    >
                      {column?.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {listData?.length > 0 ? (
                  listData?.slice(startIndex, endIndex).map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell
                        onClick={() => {
                          dispatch(setSelectedList(row));
                          dispatch(setBloodSugarFlag(true));
                          navigate(URL.form);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <EditIcon />
                      </TableCell>
                      {columns?.map((column) => (
                        <TableCell key={column?.id} align={"left"}>
                          {column?.id === "MEAL"
                            ? handleDropdownLanguageChange(
                                row,
                                column,
                                Language.BloodSugarRecords.Meal_Code_Dropdown
                              )
                            : column?.id === "BS_PTYPE"
                            ? handleDropdownLanguageChange(
                                row,
                                column,
                                Language.BloodSugarRecords
                                  .Pump_Insulin_Type_Dropdown
                              )
                            : column?.id === "BS_INTYPE"
                            ? handleDropdownLanguageChange(
                                row,
                                column,
                                Language.BloodSugarRecords.Insulin_Type_Dropdown
                              )
                            : column?.id === "BS_ITYPE"
                            ? handleDropdownLanguageChange(
                                row,
                                column,
                                Language.BloodSugarRecords.Insulin_Type_Dropdown
                              )
                            : get(
                                row?.ItemList?.find(
                                  (item) => item?.ItemId === column?.id
                                ),
                                "ItemValue",
                                ""
                              )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns?.length} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]} // Define your rows per page options
            component="div"
            count={listData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </Grid>
  );
};

export default BloodSugarRecordList;
